import type React from 'react';

import { useLabelActions } from '../../../../hooks/settings/labels/useLabelActions';
import { LabelDataModal } from './LabelDataModal';

export const CreateLabelModal: React.FC = () => {
  const { createLabel } = useLabelActions();
  return <LabelDataModal onSubmit={createLabel} />;
};

export default CreateLabelModal;
